import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import MainMenu from './main-menu'
import logo from "../images/logo.svg"; // Tell Webpack this JS file uses this image

import './index.scss'

const Logo = () => (
  <figure className="logo">
    <Link to="/">
      <img src={logo} alt="Logo" />
    </Link>  
  </figure>
)

const TemplateWrapper = ({ children, data }) => (
  <div className="page">
    <Helmet
      title={data.site.siteMetadata.sitetitle}
      meta={[
        { name: 'description', content: data.site.siteMetadata.proyecttitle },
        { name: 'keywords', content: 'fiorella patton, joyeria, orfebreria, costa rica' },
      ]}
    />
    <MainMenu />
        
    <div className="container">
      {children()}
    </div>

    <Logo />
  
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export const query = graphql`
  query LayoutQuery{
    site {
      siteMetadata {
        sitetitle
        proyecttitle
      }
    }
  }
`

export default TemplateWrapper





// WEBPACK FOOTER //
// ./src/layouts/index.js